import RwcSuggestedActions from './RwcSuggestedActions.component';

export default RwcSuggestedActions;
